import { Processo } from "./Processo";

export class PeticaoPendente {
    numeroPeticao: number;
    numeroProcesso: number;
    situacaoPeticao: string;
    titulo: string;
    idUnico: string;
    criadoEm: Date;
    juntadoEm: Date;
    tipo:string;
}

export interface CountSituacao {
    situacao: string;
    processos: Processo[],
    count: number;
}

export class PeticaoApreciada {
    apreciada: boolean;
    id: number;
    identificadorDocumento: number;
    identificadorPeticao: string; // parece que é id em string?
}

export interface VinculoPeticao {
    id: number[];
    numMinuta: number;
    tipoMinuta: string;
    texto: string;
}

export interface Vinculos {
    ids: number;
    numMinuta: number;
    tipoMinuta: string;
}